// Require

const { id, log, head } = require("../std/index")
const { findWidgetInstances } = require("../widgets/index")


// Helpers

const rxDiameter = /\s\d\d(-\d\d|\+)/;


//
// Product Details Controller
//
// Mainly just fixes titles with casing diameters in them
//

module.exports = class ProductController {
  constructor($page, $$) {
    this.cleanDiameterFromTitle($$('.title'));
    //this.linkCalcAndPriceDropdowns($page);
  }

  linkCalcAndPriceDropdowns($page) {
    const priceWidget = head(findWidgetInstances($page, 'live-price'));
    const calculator = head(findWidgetInstances($page, 'sausage-calculator'));
    calculator.onDropdownChange(priceWidget.onDropdownChange.bind(priceWidget));
  }

  cleanDiameterFromTitle($title) {
    const titleText = $title.text();
    const diamMatches = titleText.match(rxDiameter);

    if (diamMatches && diamMatches.length) {
      const diameter = diamMatches[0];
      $title.text(titleText.replace(diameter, ''));
    }
  }
};
